import React from 'react';
export function ReportIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 22V2h6v20h-6zm2-18h2v16h-2V4zM9 9v13h6V9H9zm4 2h-2v9h2v-9zM1 14v8h6v-8H1zm4 2H3v4h2v-4z"
  }));
}